// extracted by mini-css-extract-plugin
module.exports = {"content":"C_nxp","filAriane":"_2AvkA","subLink":"_1qnUx","currentPage":"_16FQZ","article":"_3Thzp","publicationDate":"_3JB5G"};